import { render, staticRenderFns } from "./TemplateArea.vue?vue&type=template&id=4bc0fd00&scoped=true&"
import script from "./TemplateArea.vue?vue&type=script&lang=js&"
export * from "./TemplateArea.vue?vue&type=script&lang=js&"
import style0 from "./TemplateArea.vue?vue&type=style&index=0&id=4bc0fd00&scoped=true&lang=css&"
import style1 from "./TemplateArea.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc0fd00",
  null
  
)

export default component.exports